import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetAdmin = LazyLoad(() => import('./PetAdmin'));

export { PetAdmin };
